export const INTEGRATION = "integration";
const PLANNED = "planned";
const I = INTEGRATION;
const P = PLANNED;

const GROUPS = [
  {
    title: "Canada · Parcel & courier",
    i18nKey: "carriers.upcoming.groups.caParcel",
    items: [
      ["Purolator", "PUR", I], ["Loomis Express", "LMX", I], ["Intelcom", "ICM", I],
      ["UniUni", "UNI", P], ["Chit Chats", "CCH", P], ["Stallion Express", "STX", P], ["Flashbox", "FBX", P],
    ],
  },
  {
    title: "Canada · LTL & freight",
    i18nKey: "carriers.upcoming.groups.caFreight",
    items: [
      ["Day & Ross", "D&R", I], ["Purolator Freight", "PFR", I], ["Manitoulin Transport", "MTL", P],
      ["TST-CF Express", "TST", P], ["Kindersley Transport", "KTL", P], ["Midland Transport", "MID", P],
      ["Polaris Transportation", "POL", P], ["Speedy Transport", "SPD", P], ["Maritime-Ontario", "M-O", P],
      ["Groupe Guilbault", "GLT", P],
    ],
  },
  {
    title: "USA · Parcel & postal",
    i18nKey: "carriers.upcoming.groups.usParcel",
    items: [
      ["USPS", "USPS", I], ["OnTrac", "ONT", P], ["Amazon Shipping", "AMZ", P], ["DHL eCommerce", "DHLe", P],
      ["LSO", "LSO", P], ["Spee-Dee Delivery", "SDD", P], ["Veho", "VEH", P], ["GLS US", "GLSu", P],
    ],
  },
  {
    title: "USA · LTL & freight",
    i18nKey: "carriers.upcoming.groups.usFreight",
    items: [
      ["Old Dominion", "ODFL", P], ["Estes Express", "EST", P], ["Saia", "SAIA", P], ["XPO", "XPO", I],
      ["ABF Freight", "ABF", P], ["R+L Carriers", "R+L", P], ["TForce Freight", "TFF", P],
      ["Southeastern Freight Lines", "SEFL", P], ["Averitt Express", "AVE", P],
    ],
  },
];

export const CONNECT_PREVIEW = ["Purolator", "Loomis Express", "USPS"];

const DOMAINS = {
  "Intelcom": "intelcom.ca", "UniUni": "uniuni.com", "Chit Chats": "chitchats.com",
  "Stallion Express": "stallionexpress.ca", "Manitoulin Transport": "manitoulintransport.com",
  "Kindersley Transport": "kindersleytransport.com", "Midland Transport": "midlandtransport.com",
  "Maritime-Ontario": "m-o.com", "Groupe Guilbault": "guilbault.ca", "USPS": "usps.com",
  "LSO": "lso.com", "Spee-Dee Delivery": "speedeedelivery.com", "Veho": "shipveho.com",
  "GLS US": "gls-us.com", "Old Dominion": "odfl.com", "ABF Freight": "arcb.com",
  "TForce Freight": "tforcefreight.com", "Southeastern Freight Lines": "sefl.com", "Averitt Express": "averitt.com",
};

const wiki = (file) =>
  `https://commons.wikimedia.org/wiki/Special:FilePath/${encodeURIComponent(file)}?width=300`;

const LOGO_OVERRIDES = {
  "DHL eCommerce": wiki("DHL_Logo.svg"),
  "Estes Express": wiki("Estes_Express_Lines_logo.svg"),
  "XPO": wiki("XPO_Logistics_logo.svg"),
  "R+L Carriers": wiki("R+L_Carriers_logo.svg"),
  "Purolator": wiki("Purolator_Logo.svg"),
  "Purolator Freight": wiki("Purolator_Logo.svg"),
  "Saia": wiki("Saia_logo.svg"),
  "Amazon Shipping": wiki("Amazon_logo.svg"),
  "OnTrac": wiki("OnTrac_logo.svg"),
  "Loomis Express": "https://icon.horse/icon/loomis-express.com",
  "Flashbox": "https://www.google.com/s2/favicons?domain=flashbox.ca&sz=128",
};

const logoFor = (name) =>
  LOGO_OVERRIDES[name] ??
  (DOMAINS[name] ? `https://www.google.com/s2/favicons?domain=${DOMAINS[name]}&sz=128` : undefined);

const GENERIC_SUFFIXES = ["express", "transport", "transportation", "logistics", "courier", "inc"];

const normalize = (name) =>
  (name ?? "").toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]/g, "");

const sameCarrier = (a, b) =>
  a === b ||
  GENERIC_SUFFIXES.some((suffix) => a === b + suffix || b === a + suffix);

export const upcomingGroups = (availableNames) => {
  const available = availableNames.map(normalize);
  const isAvailable = (name) => available.some((known) => sameCarrier(known, normalize(name)));

  return GROUPS.map(({ title, i18nKey, items }) => ({
    title,
    i18nKey,
    items: items
      // The backend sometimes lists a carrier by its short code (e.g. "MO" for Maritime-Ontario).
      .filter(([name, code]) => !isAvailable(name) && !isAvailable(code))
      .map(([name, code, status]) => ({ name, code, status, logo: logoFor(name) })),
  })).filter((group) => group.items.length);
};
